export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";